angular.module('common.directives').directive('surfMp4Player', function () {
  return {
    scope: {
      videoData: '=',
      onVideoMetadataUpdate: '&',
      closePlayer: '&'
    },
    templateUrl:
      './templates/surf-mp4-player.view.html?t=' + window.webpackHash,
    link: function ($scope, $element) {},
    controller: 'surfMp4PlayerController'
  }
})
